import Vue from "vue";
import PhoneMaskInput from "./PhoneMaskInput.vue";

export default Vue.component('phone-mask-input', PhoneMaskInput);